export const AVAILABILITY_TARGET_DEFAULT_VALUE = 98
export const DEPOT_INBOUND_TARGET_DEFAULT_VALUE = 98
